import clientSay4 from "images/client2.png";
import clientSay7 from "images/client7.png";
import clientSay12 from "images/client12.png";
import clientSay13 from "images/client13.png";
import clientSay15 from "images/client15.png";
import clientSay19 from "images/client19.png";
import clientSay20 from "images/client20.png";

export const globalJson = {
  prod_company_id: 238,
  dev_company_id: 238,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://AMK Elite Car Rentals-dev.1now.app",
  sender: "AMK Elite Car Rentals",
  ccEmail: "AMK Elite Car Rentals@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "AMK Elite Car Rental is a family-owned business committed to providing a seamless and premium car rental experience. We offer a curated fleet of luxury and performance vehicles, delivering to Sacramento International Airport (SMF) and other custom locations for your convenience. Whether for business, leisure, or special occasions, we take pride in delivering top-tier service tailored to your needs.",

  clientSays_arr: [
    {
      id: 1,
      clientName: "Diana Tarakanova",
      clientAddress: "Townsed, Delaware",
      content:
        "We got a BMW X5 for a work trip and were seriously impressed! The car drove like a dream—steady on the road, super comfortable, and worth every penny. We almost extended the rental because we didn’t want to give it back! AMK made the whole process easy. Five stars, and we’ll definitely be back next time we’re in Sacramento.",
    },
    {
      id: 2,
      clientName: "Julieta Brooks",
      clientAddress: "Hockessin, Delaware",
      content:
        "Wow! What a car! It drives smoothly and it’s spacious! Did I mention how beautiful it is too? Made this mom of two littles feel safe, comfortable, and a bit fancy! ❤️ the costumer service was on point and I’d get a response within 15 minutes! If I’m ever in Sacramento again I know who to reach out to",
      img: clientSay4,
    },
    {
      id: 3,
      clientName: "Hailey Tabarez",
      clientAddress: "Dover, Delaware",
      content:
        "I had the pleasure of renting from Aleksandr. The car was in wonderful condition! Communication was fast and pickup instructions were easy to follow. Last minute I needed to extend my trip and Aleksandr was very accommodating. 10/10 would recommend renting from him. I know I will again!",
    },
    {
      id: 4,
      clientName: "Q Dubb",
      clientAddress: "Elsmere, Delaware",
      content:
        "Great company with a fleet of cars you won't find at your typical car rental place. I had a sweet Audi Q7 Quattro that got compliments from my family members. Host is professional and prompt. Would definitely recommend!",
    },
    {
      id: 5,
      clientName: "Nariman Narimanov",
      clientAddress: "Elsmere, Delaware",
      content:
        "Thank you so much for the car rental! The vehicle was exceptionally clean, and the service was absolutely professional. They were always in touch with me and made the whole experience smooth and easy. Truly high-class service — one of the best I’ve ever had. Highly recommend!",
    },
    {
      id: 6,
      clientName: "Thomas S.",
      clientAddress: "Elsmere, Delaware",
      content:
        "We had an amazing experience with AMK Elite Car Rental for our recent family trip. We rented a brand-new black Ford Expedition, which was not only beautiful but also in pristine condition. The pickup and drop-off process was seamless, thanks to the clear and easy instructions provided by the hosts. They were incredibly accommodating to our requests, making the entire rental experience smooth and hassle-free. AMK Elite Car Rental truly exceeded our expectations, and we highly recommend them to anyone looking for a reliable and top-notch rental service. We will definitely be renting from them again! 10/10",
    },
    {
      id: 7,
      clientName: "Rey STi 2k19 Sanchez",
      clientAddress: "Elsmere, Delaware",
      content:
        "Really nice car and a lot of space for 8 people… ride really nice as well. Communication with Alex is so easy and simple and the pick up and drop are very simple. Will give him 5 star for the renting experience. Will definitely rent again from them. AMK ELITE CAR RENTAL!!!",
      img: clientSay7,
    },
    {
      id: 8,
      clientName: "Eugene Yelenskiy",
      clientAddress: "Elsmere, Delaware",
      content:
        "We loved our Experience with AMK Elite Car Rental. Very responsive, great customer service, they have a nice variety of high end vehicles. Overall phenomenal experience will be using them again, along with recommending to everyone.",
    },
    {
      id: 9,
      clientName: "John Banderas",
      clientAddress: "Elsmere, Delaware",
      content:
        "I rented their BMW X5 and i absolutely loved the car, service and process! It was absolutely a pleasant experience. The car was clean, smelled great and drive amazing! Plus free car washes you are bound to always drive in style! Thank you so much to these amazing hosts. I will definitely be coming back!",
    },
    {
      id: 10,
      clientName: "Diana Tarakanova",
      clientAddress: "Elsmere, Delaware",
      content:
        "We got a BMW X5 for a work trip and were seriously impressed! The car drove like a dream—steady on the road, super comfortable, and worth every penny. We almost extended the rental because we didn’t want to give it back! AMK made the whole process easy. Five stars, and we’ll definitely be back next time we’re in Sacramento",
    },
    {
      id: 11,
      clientName: "Mitch Valder",
      clientAddress: "Elsmere, Delaware",
      content:
        "We were upgraded at no cost to the 2019 X5. Delivered ahead of schedule. Car was really clean and interior smelled nice. A treat to drive. Owner was very responsive. Great experience.",
    },
    {
      id: 12,
      clientName: "S Rigney",
      clientAddress: "Elsmere, Delaware",
      content:
        "Had a great rental with AMK. Owner’s communication before, during, and after the rental was very clear with all directions and location of pickup / delivery. Vehicle was super clean and as per listing. Wouldn’t hesitate to rent again.",
      img: clientSay12,
    },
    {
      id: 13,
      clientName: "John Beretz",
      clientAddress: "Elsmere, Delaware",
      content:
        "Just returned the car after renting it for a 4 day weekend. The folks at AMK made the process simple, and they were very accommodating. Unlike your typical rental car companies, we knew exactly which car we were reserving and the vehicle was high-end and fully loaded. We will absolutely rent from AMK again!",
      img: clientSay13,
    },
    {
      id: 14,
      clientName: "RJC",
      clientAddress: "Elsmere, Delaware",
      content:
        "I just finished my trip using one of their cars. I can’t tell you how nice of an experience it was. From the easy pick up (and even being ready early!) from a very nice location to the amazing car. It was very clean inside, smelled amazing and was such a smooth ride. I would highly recommend using them for a rental if you’re in the area, I will definitely be using them again!",
    },
    {
      id: 15,
      clientName: "Joanna Shirley",
      clientAddress: "Elsmere, Delaware",
      content:
        "Wonderful customer service! The Expedition was clean and in perfect shape. It made our trip from Sac to Napa so easy. We will be in contact when we come back.",
      img: clientSay15,
    },
    {
      id: 16,
      clientName: "Melanie Aiona",
      clientAddress: "Elsmere, Delaware",
      content:
        "Absolutely fabulous vehicle! Handled treacherous snowy road conditions just perfectly. Super easy rental process with a very responsive and helpful host. Mahalo!",
    },
    {
      id: 17,
      clientName: "Chelsea Van",
      clientAddress: "Elsmere, Delaware",
      content:
        "I had a really enjoyable experience with this host, Aleksandr from AMK Elite Car Rental. From the start, the communication was incredibly fast and efficient, making the whole process smooth stress-free, and insanely quick. The car was delivered ahead of the scheduled time, which was a huge plus, and picked up without me having to drop it off. Honestly, this was the best car rental experience I've had. This was my first time using Turo, and AMK Elite made it an enjoyable and hassle-free experience.",
    },
    {
      id: 18,
      clientName: "Hailey Tabarez",
      clientAddress: "Elsmere, Delaware",
      content:
        "I had the pleasure of renting from Aleksandr. The car was in wonderful condition! Communication was fast and pickup instructions were easy to follow. Last minute I needed to extend my trip and Aleksandr was very accommodating. 10/10 would recommend renting from him. I know I will again!",
    },
    {
      id: 19,
      clientName: "Daniel McCollum",
      clientAddress: "Elsmere, Delaware",
      content:
        "Perfect trip! I had originally booked a different vehicle in their fleet but due to some maintenance I was rebooked to this Cayenne. The swap was super fast and easy and communicated well by Alex. The car was super clean and drove perfectly. Alex was great and I'd definitely rent from him again!",
      img: clientSay19,
    },
    {
      id: 20,
      clientName: "carleen vu",
      clientAddress: "Elsmere, Delaware",
      content:
        "This was my first time renting on Turo and it will not be my last. AMK Elite was the easiest car rental I’ve ever had! The car was beautiful and clean, as well as a smooth ride. I will definitely rent with them again.",
      img: clientSay20,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2",

  //contact
  address: "1911 Finney Way, Lincoln, CA, 95648",
  operating_time: "09:00 am - 7:00 pm",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "+1 (916)906-5099",
  email: "Amkelitecarrentals@gmail.com",
  company_name: "AMK Elite Car Rentals",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
